<template>
  <div class="row">
    <!-- <general-top-bar :title="$t('pages.gestiune')"></general-top-bar> -->
    <div class="box-container row tabs-dispatch">
      <div
        v-for="(route, index) in managementRoutes"
        :key="route.key"
        class="col-md-4"
      >
        <template v-if="!route.right || route.right && userHasRight(route.right)">
          <router-link
            :to="route.path"
            class="box"
            :style="{ backgroundColor: getBoxColor(index) }"
          >
            <div class="title">{{ $t('gestiune.' + route.key) }}</div>
            <div class="image">
              <img :src="getImageForRoute(route.key)" :alt="'Image for ' + route.key" />
            </div>
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

export default {
  components: {
    // GeneralTopBar
  },
  data () {
    return {
      managementRoutes: [
        { path: '/management/sidebar?tab=dashboard', key: 'dashboard', right: 'can_access_dashboard' },
        { path: '/management/sidebar?tab=outputs', key: 'outputs', right: 'can_access_gestiune' },
        { path: '/management/sidebar?tab=entries', key: 'entries', right: 'can_generate_nir' },
        { path: '/management/sidebar?tab=stocks', key: 'stocks', right: 'can_access_gestiune' },
        { path: '/management/sidebar?tab=production', key: 'production', right: 'can_access_gestiune' },
        { path: '/management/sidebar?tab=reteta', key: 'reteta', right: 'can_access_gestiune' },
        { path: '/management/sidebar?tab=ordersSuppliers', key: 'ordersSuppliers', right: 'can_access_supplier_orders' },
        { path: '/management/sidebar?tab=reports', key: 'reports', right: 'can_access_reports' },
        { path: '/management/sidebar?tab=settings', key: 'settings', right: 'can_access_settings' }
      ]
    }
  },
  async mounted () {
    this.companyID = this.$session.get('selectedCompany')
  },
  methods: {
    getImageForRoute (routeKey) {
      const images = {
        'dashboard': 'static/img/dispatch-settings.png',
        'outputs': 'static/img/dispatch-settings.png',
        'stocks': 'static/img/dispatch-settings.png',
        'entries': 'static/img/dispatch-settings.png',
        'production': 'static/img/dispatch-settings.png',
        'reteta': 'static/img/dispatch-settings.png',
        'ordersSuppliers': 'static/img/dispatch-settings.png',
        'reports': 'static/img/dispatch-settings.png',
        'settings': 'static/img/dispatch-settings.png'
      }
      return images[routeKey] || 'static/img/default.jpg'
    },
    getBoxColor (index) {
      const colors = [
        '#3AB7CD',
        '#3AB7CD',
        '#674BD2',
        '#FF6B6B',
        '#FFD93D',
        '#17B086',
        '#FF6B6B',
        '#FFD93D',
        '#FFD93D',
        '#FFD93D',
        '#FFD93D',
        '#17B086'
      ]
      return colors[index] || '#FFFFFF' // Default color
    }
  }
}
</script>

<style scoped>
.box-container.row {
  max-width: 1300px;
  margin-top: 30px;
  margin: auto;
}
.tabs-dispatch {
  margin-top: 40px;
}
.box-container.row .image {
  position: absolute;
  bottom: 0;
}
.box-container .col-md-4 {
  width: 24.333333%;
}
.box {
  position: relative;
  margin-bottom: 30px;
  text-align: center;
  display: block;
  text-decoration: none;
  color: inherit;
  border-radius: 30px;
  width: 280px;
  height: 280px;
}
.title {
  margin-bottom: 8px;
  padding: 30px 0px;
  color: #fff;
  font-size: 20px;
  font-weight: 500;
}
.image img {
  width: 100%;
  height: auto;
  max-width: 100%;
  display: block;
  margin: 0 auto 0px;
  border-top-right-radius: 50px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/ManagementTabs.vue